import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ae6265a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "transaction-raw-bytes",
  "data-testid": "raw-bytes"
}
const _hoisted_2 = { class: "monospace scrollable" }

type Props = {
  data?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionRawBytes',
  props: {
    data: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.data), 1 /* TEXT */)
  ]))
}
}

})